export const SCALE_COLORS = [
  "#97D8B2",
  "#9EC585",
  "#A4B158",
  "#D2AC48",
  "#FFA737",
  "#F79832",
  "#EE892C",
  "#DD6B20",
  "#D14E28",
  "#C53030",
];

export const REVERSE_SCALE_COLORS = [...SCALE_COLORS].reverse();
